import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import amplitude from 'amplitude-js';
import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { CardAccountRow, CardAccountSubrow, IconWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { CARD_MAIN_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { ACCOUNT_CURRENCY, CARD_TYPE, FROM } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { cardType, MAIN_CA_SCREEN } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_GA_CARD, AUTH_GA_CARD_ORDER_PLASTIC, AUTH_GA_CARDS } from 'apps/auth/constants/UrlConstants';

const StatusText = styled(Text)`
    margin-left: 8px;
`;

const PanelForCard = (props) => {
    const card = props.card;

    const getPanelStatus = () => {
        if (card.pendingActivation) {
            return <Badge caption={props.activate} size="fit" variant="primary" />;
        } else if (card.activeWithoutPin) {
            return <Badge caption={props.activate_without_pin} size="fit" variant="tertiary" />;
        } else if (card.frozen) {
            return <Badge caption={props.frozen} size="fit" variant="primary" />;
        } else if (card.expired) {
            return <Badge caption={props.expired} size="fit" variant="tertiary" />;
        }
        return (
            <StatusText color="secondary">
                {card.formattedAmount}&nbsp;
                <Text color="secondary" smallCaps>
                    {card.cardPocket.currency.code.toLowerCase()}
                </Text>
            </StatusText>
        );
    };

    const amplitudeEventForViewCard = (virtual, code) => {
        amplitude.getInstance().logEvent(CARD_MAIN_SCREEN_SHOWN, {
            [CARD_TYPE]: virtual ? cardType.VIRTUAL : cardType.PLASTIC,
            [ACCOUNT_CURRENCY]: code,
            [FROM]: MAIN_CA_SCREEN,
        });
    };

    const getCardHref = () => {
        let href = '';
        if (card.needToCreatePin) {
            href = `${AUTH_GA_CARDS}/plastic/${card.id}/need/pin`;
        } else if (card.pendingActivation) {
            href = `${AUTH_GA_CARD_ORDER_PLASTIC}/status/${card.id}`;
        } else {
            href = `${AUTH_GA_CARD}${card.id}`;
        }
        return href;
    };

    const existingPaySystems = ['mastercard', 'mc', 'visa'];

    const getCardIconName = () => {
        return existingPaySystems.includes(card.paySystem) ? card.paySystem : 'other';
    };

    const getCardIconColor = () => {
        if (card.plastic) {
            if (card.frozen || card.expired || card.pendingActivation) {
                return 'lightGray';
            } else {
                return 'primary';
            }
        } else {
            if (card.frozen || card.expired) {
                return 'lightGray';
            } else {
                return 'primary';
            }
        }
    };

    return (
        <Panel
            type="reactLink"
            to={getCardHref()}
            hasBorderRadius
            isBordered
            onClick={() => {
                amplitudeEventForViewCard(card.virtual, card.cardPocket.currency.code);
            }}
        >
            <CardAccountRow>
                <IconWrapper>
                    <Icon size="56px" name={`cardp-${card.virtual ? '' : 'full-'}${getCardIconName()}`} color={getCardIconColor()} />
                </IconWrapper>
                <CardAccountSubrow>
                    <Text ellipsis color={card.frozen || card.expired ? 'lightGray' : 'primary'}>
                        {card.virtual ? props.virtual : props.plastic}
                    </Text>
                    {getPanelStatus()}
                </CardAccountSubrow>
            </CardAccountRow>
        </Panel>
    );
};

const mapStateToProps = (state) => {
    return {
        activate: state.messages.pageMessages.activate,
        activate_without_pin: state.messages.pageMessages.activate_without_pin,
        frozen: state.messages.pageMessages.frozen,
        virtual: state.messages.pageMessages.virtual,
        plastic: state.messages.pageMessages.plastic,
        expired: state.messages.pageMessages.expired,
    };
};
export default connect(mapStateToProps)(PanelForCard);
